module.exports = __webpack_public_path__ + "static/img/1.d9ac874.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/1.png
// module id = wmCF
// module chunks = 0